const defOptions = {
  threshold: 1,
  // handler only will trigger onece when observed element was intersected.
  once: true,
  // trigger handler only when all entries is visible.
  visibleOnly: true
};

export default class SingleElementIntersectionObserver {
  constructor(intersectionHandler, options = {}) {
    options = Object.assign({}, defOptions, options);

    this._observer = new IntersectionObserver((entries, observer) => {
      let entry = entries[0];

      if (options.visibleOnly) {
        // IMPORTANT:
        // The callback will always be trigger when observed element appeared at the first time, even
        // it's not visible in viewport.
        // So, you must make sure the intersection ratio of all entries are above threshold,
        // that means the observed element is actually visible so that we can trigger the handler.

        // let isAllEntriesVisible = true;
        // entries.forEach(entry => {
        //   isAllEntriesVisible = entry.isIntersecting && isAllEntriesVisible;
        // });
        // if (!isAllEntriesVisible) {
        //   return;
        // }

        if (!entry.isIntersecting) {
          return;
        }
      }

      if (options.once) {
        this.unobserve();
      }

      /*
      entry properties:
      ---------------------
      boundingClientRect: DOMRectReadOnly {x: 689.015625, y: 4082, width: 82, height: 57, top: 4082, …}
      intersectionRatio: Number 0~1
      intersectionRect: DOMRectReadOnly {x: 0, y: 0, width: 0, height: 0, top: 0, …}
      isIntersecting: false
      rootBounds: DOMRectReadOnly {x: 0, y: 0, width: 792, height: 626, top: 0, …}
      target: HTMLElement
      time: 19974.00000000198
      */
      intersectionHandler(entry, observer);
    }, options);
  }

  observe(elm) {
    if (!elm) {
      return;
    }
    this.unobserve();
    this._observedElm = elm;
    this._observer.observe(elm);
  }

  unobserve() {
    if (this._observedElm) {
      this._observer.unobserve(this._observedElm);
    }
  }

  disconnect() {
    this._observer.disconnect();
  }
}